import * as React from "react";

import { FlexComponent } from "src/typings/flexFramework/FlexComponent";
import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouterAndCustomerNotifications } from "components/shared/StorefrontWizard/LobQueryRouterAndCustomerNotifications/LobQueryRouterAndCustomerNotifications";

interface TabbedWizardProps {
  isStorefrontPage: boolean;
  wizardLOBs: FlexComponent[];
  context: any;
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tab: string) => void;
}

export const WizardTabbed = ({
  isStorefrontPage,
  wizardLOBs,
  context,
  wizardFormChildren,
  trackOnChangeTab,
}: TabbedWizardProps) => {
  return (
    <>
      <LobQueryRouterAndCustomerNotifications isStorefrontPage={isStorefrontPage} wizardLOBs={wizardLOBs} />

      <LobFormWithTabs
        context={context}
        lobForms={wizardFormChildren}
        wizardFormClassNames="all-x-padding-six"
        tabGroupClassNames="all-l-padding-six"
        trackOnChangeTab={trackOnChangeTab}
      />
    </>
  );
};
